import { render, staticRenderFns } from "./content_admin.vue?vue&type=template&id=6956139a&scoped=true&"
import script from "./content_admin.vue?vue&type=script&lang=js&"
export * from "./content_admin.vue?vue&type=script&lang=js&"
import style0 from "./content_admin.vue?vue&type=style&index=0&id=6956139a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956139a",
  null
  
)

export default component.exports